import { render, staticRenderFns } from "./B2BSignInTable.vue?vue&type=template&id=928b35e0&"
import script from "./B2BSignInTable.vue?vue&type=script&lang=js&"
export * from "./B2BSignInTable.vue?vue&type=script&lang=js&"
import style0 from "./B2BSignInTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports